export default {
      id: "oc-dashboard-fee-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-fee",
      toString: function () {
        return this.url;
      }
    }